<div mat-dialog-title style="padding-bottom: 0;">
  Selecci&oacute;n De/Para
  <br />
</div>
<mat-dialog-content class="mat-typography">
  <div class="row">
    <div class="col-sm-3">
      <mat-form-field class="full-width">
        <mat-label>Tipo usuario</mat-label>
        <mat-select [(value)]="tipoSolicitanteDefault" (selectionChange)="onChangeTipo($event.value)">
          @for (tipoSolicitante of tiposSolicitantes; track $index) {
          <mat-option value={{tipoSolicitante.id}}>{{tipoSolicitante.descripcion}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    @if (selectedTipoSol === "-1"){
    <div class="col-sm-4">
      <mat-form-field class="full-width">
        <mat-label>Lista de env&iacute;o</mat-label>
        <mat-select (selectionChange)="onChangeListaEnvio($event.value)">
          @for (lst of listasEnvio; track $index) {
          <mat-option value={{lst.id}}>{{lst.nombre}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    }
    <div class="col-sm-{{(this.selectedTipoSol==='-1')?5:9}}">
      <mat-form-field class="full-width">
        <mat-label>Filtrar</mat-label>
        <input autoFocus matInput #filter placeholder="{{placeholder}}" [minLength]="numCaracteres"
          (keyup)="onKeyUp($event)" (input)="filterChanged()" [(ngModel)]="filtro" />
        @if(filter.value.trim().length<numCaracteres){ <mat-hint style="color: red;">Ingrese al menos {{numCaracteres}}
          caracteres para filtrar
          datos </mat-hint>
          }
          @if (selectedTipoSol === "2" && noCitizens) {
          <button matSuffix mat-icon-button aria-label="A&ntilde;adir ciudadano" (click)="openDlgAddCitizen()">
            <mat-icon>add</mat-icon>
          </button>
          }
          <button matSuffix mat-icon-button aria-label="Filtrar" (click)="onFilter(filter.value)">
            <mat-icon>search</mat-icon>
          </button>
      </mat-form-field>
    </div>
  </div>
  <div class="example-table-container">
    @if (selectedTipoSol !== "3") {
    <table mat-table [dataSource]="dataSource" style="height: auto;">

      <ng-container matColumnDef="ciruc">
        <th mat-header-cell *matHeaderCellDef>CI/RUC</th>
        <td mat-cell *matCellDef="let element">{{ element.ciruc }}</td>
      </ng-container>

      <ng-container matColumnDef="nombres">
        <th mat-header-cell *matHeaderCellDef>Nombres</th>
        <td mat-cell *matCellDef="let element">{{ element.nombres }}<p class="descripcion">{{
            element.departamento }} {{element.titulo}} {{element.cargo.length > 0 ? " - " + element.cargo : "" }}</p>
        </td>
      </ng-container>

      <ng-container matColumnDef="opt">
        <th mat-header-cell *matHeaderCellDef>&nbsp;</th>
        <td mat-cell *matCellDef="let element" style="max-width: min-content;">
          <mat-button-toggle-group name="fontStyle" hideSingleSelectionIndicator="signal(false)">
            <mat-button-toggle value="de" (click)="onSelect(element,2)">De</mat-button-toggle>
            <mat-button-toggle value="para" (click)="onSelect(element,1)">Para</mat-button-toggle>
            <mat-button-toggle value="copia" (click)="onSelect(element,3)">Copia</mat-button-toggle>
          </mat-button-toggle-group>
        </td>
      </ng-container>

      <ng-container matColumnDef="uso">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          @if (selectedTipoSol === "2") {
          <button mat-icon-button matTooltip="Editar" (click)="openDlgUpdateCitizen(element)">
            <mat-icon>edit</mat-icon>
          </button>
          }
          <mat-icon class="ultimo-uso-{{element.fechaUso|ultimoUso}}">boy</mat-icon>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      <tr class="mat-row" *matNoDataRow>
        @if(dataSource.data.length <= 0 && !clearData){ @if (filter.value.trim().length>= 4) {
          <td class="mat-cell" colspan="4">
            No hay datos que coincidan con el filtro "{{filter.value}}"
          </td>
          }
          }@else {
          <td class="mat-cell" colspan="4">Ingrese un criterio de b&uacute;squeda</td>
          }
      </tr>
    </table>
    }
    @if(selectedTipoSol === "3") {
    <table mat-table [dataSource]="buzonesDataSource" style="height: auto;">

      <ng-container matColumnDef="departamento">
        <th mat-header-cell *matHeaderCellDef>Departamento</th>
        <td mat-cell *matCellDef="let element">{{ element.departamento }}</td>
      </ng-container>

      <ng-container matColumnDef="cargo">
        <th mat-header-cell *matHeaderCellDef>Cargo/nombre del buzón</th>
        <td mat-cell *matCellDef="let element">{{ element.cargo }}</td>
      </ng-container>

      <ng-container matColumnDef="opt">
        <th mat-header-cell *matHeaderCellDef>&nbsp;</th>
        <td mat-cell *matCellDef="let element" style="max-width: min-content;">
          <mat-button-toggle-group name="fontStyle" hideSingleSelectionIndicator="signal(false)">
            <mat-button-toggle value="para" (click)="onSelectBuzon(element,1)">Para</mat-button-toggle>
          </mat-button-toggle-group>
          <button mat-flat-button color="primary" class="btn-integrantes" matTooltip="Mostrar integrantes del buzón" aria-label="Integrantes" (click)="openIntegrantes(element)">
            <mat-icon>people</mat-icon>
            <span class="btn-label">Integrantes</span>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="buzonesDisplayedColumns;sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: buzonesDisplayedColumns"></tr>
      <tr class="mat-row" *matNoDataRow>
        @if(dataSource.data.length <= 0 && !clearData){ @if (filter.value.trim().length>= 4) {
          <td class="mat-cell" colspan="4">
            No hay datos que coincidan con el filtro "{{filter.value}}"
          </td>
          }
          }@else {
          <td class="mat-cell" colspan="4">Ingrese un criterio de b&uacute;squeda</td>
          }
      </tr>
    </table>
    }
  </div>
  <div class="row" style="padding-top: 12px;border-top: 1px solid gray;">
    <div class="col-s12">
      <div class="col-12" style="display: inline-grid;align-items: center;">
        <span style="width: 48px; font-weight: bold;">De:&nbsp;</span>
        <!--<img src="assets/vacio.png" class="foto-de">-->
        @for (participante of participantes.origen; track $index) {
        <div style="display: inline-flex;padding-left: 48px;">
          <div style="display: flex;align-items: center;padding-left: 16px">
            <button mat-icon-button matTooltip="Eliminar" (click)="onRemove(0, participante)">
              <mat-icon>delete</mat-icon>
            </button>

            <span style="font-weight: 100;">
              {{participante!.titulo}}
              {{participante!.nombres | capitalize}}
              @if(participante.cargo){
              ({{(participante.cargo||'')}})
              }
            </span>
          </div>
        </div> }
      </div>
      <div class="col-12" style="display: inline-grid;align-items: center;">
        <span style="width: 48px; font-weight: bold;">Para:&nbsp;</span>
        <!--<img src="assets/vacio.png" class="foto-para">-->
        @for (buzon of participantes.destinoBuzon; track $index) {
        <div style="display: inline-flex;padding-left: 48px;">
          <div style="display: flex;align-items: center;padding-left: 16px">
            <button mat-icon-button matTooltip="Eliminar" (click)="onRemoveBuzon(buzon)">
              <mat-icon>delete</mat-icon>
            </button>
            <span style="font-weight: 100;">
              {{buzon.cargo}}
              {{(buzon.departamento||'')}}
            </span>
          </div>
        </div>
        }
        @for (participante of participantes.destino; track $index) {
        <div style="display: inline-flex;padding-left: 48px;">
          <div style="display: flex;align-items: center;padding-left: 16px">
            <button mat-icon-button matTooltip="Eliminar" (click)="onRemove(1, participante)">
              <mat-icon>delete</mat-icon>
            </button>

            <span style="font-weight: 100;">
              {{participante.titulo}}
              {{participante.nombres | capitalize}}
              @if(participante.cargo){
              ({{(participante.cargo||'')}})
              }
            </span>
          </div>
        </div>
        }
      </div>
      <div class="col-12" style="display: inline-grid;align-items: center;">
        <span style="width: 48px; font-weight: bold;">Copia:&nbsp;</span>
        @if(participantes.copia){
        @for (participante of participantes.copia; track $index) {
        <div style="display: inline-flex;padding-left: 48px;">
          <!--<img src="assets/vacio.png" class="foto-para">-->
          <div style="display: flex;align-items: center;padding-left: 16px">
            <button mat-icon-button matTooltip="Eliminar" (click)="onRemove(2, participante)">
              <mat-icon>delete</mat-icon>
            </button>
            <span style="font-weight: 100;">
              {{participante.titulo}}
              {{participante.nombres | capitalize}}
              @if(participante.cargo){
              ({{(participante.cargo||'')}})
              }
            </span>
          </div>
        </div>
        }
        }
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions style="display: flex;">
  <div style="float: left; font-weight: 100; font-size: small;">
    <mat-icon class="ultimo-uso-7">boy</mat-icon> 7 d&iacute;as,
    <mat-icon class="ultimo-uso-30">boy</mat-icon> 30 d&iacute;as,
    <mat-icon class="ultimo-uso-31">boy</mat-icon> +30 d&iacute;as
  </div>
  <span class="sgd-spacer"></span>
  <button mat-button mat-dialog-close>Cancelar</button>
  <button mat-flat-button [mat-dialog-close]="participantes" cdkFocusInitial>Aceptar</button>
</mat-dialog-actions>